'use client';

import React, { ReactNode, createContext, useContext } from 'react';

export enum YMGoal {
  NUMBER_CLICK = 'NUMBER_CLICK',
  REGISTRATION_CLICK = 'REGISTRATION_CLICK',
  EMAIL_CLICK = 'EMAIL_CLICK',
  FORM_SUCCESS = 'FORM_SUCCESS',
}

declare global {
  interface Window {
    ym?: (id: number, action: string, target: string) => void;
  }
}

interface MetrikaContextType {
  captureGoal: (goal: string) => void;
}

const MetrikaContext = createContext<MetrikaContextType | undefined>(undefined);

export const MetrikaProvider = ({ children, counterId }: { children: ReactNode; counterId: number | null }) => {
  const captureGoal = (goal: string) => {
    try {
      if (counterId && typeof window !== 'undefined' && window.ym) {
        window.ym(counterId, 'reachGoal', goal);
      }
    } catch (e) {
      console.error(e);
    }
  };

  return <MetrikaContext.Provider value={{ captureGoal }}>{children}</MetrikaContext.Provider>;
};

export const useMetrika = () => {
  const context = useContext(MetrikaContext);
  if (!context) {
    throw new Error('useMetrika must be used within a MetrikaProvider');
  }
  return context;
};
